// ألوان تمييز نوع الإجازة (شريط جانبي/شارة) بنفس لوحة عدّادات الرصيد.
export const LEAVE_TONE = {
  sick: { bar: "bg-blue-500", text: "text-blue-500" },
  emergency: { bar: "bg-amber-500", text: "text-amber-500" },
  time_off: { bar: "bg-purple-500", text: "text-purple-500" },
  annual: { bar: "bg-emerald-500", text: "text-emerald-500" },
  unpaid: { bar: "bg-slate-500", text: "text-slate-500" },
};

export const toneFor = (leaveType) => LEAVE_TONE[leaveType] || { bar: "bg-primary", text: "text-primary" };
